/**
 * Audio Editor
 * Handles configuration for audio display controls
 */

import React from 'react';
import type { PropertyEditor, PropertyEditorProps } from '../../../registry/PropertyEditor.types';

/**
 * Render function for audio control
 */
function renderAudioEditor(props: PropertyEditorProps) {
  const { control, onConfigChange } = props;

  return (
    <div className="af-properties-tab__section">
      <h4 className="af-properties-tab__subsection-title">Control Configuration</h4>
      <div className="af-properties-tab__group">
        <label className="af-properties-tab__label">
          Audio URL
          <input
            type="text"
            value={(control.config?.src as string) || ''}
            onChange={(e) => onConfigChange('src', e.target.value || undefined)}
            className="af-properties-tab__input"
            placeholder="https://..."
          />
        </label>
      </div>
    </div>
  );
}

/**
 * AudioEditor - Handles audio control configuration
 */
export const AudioEditor: PropertyEditor = {
  type: 'audio',
  label: 'Audio',
  description: 'Configure audio URL for audio player control',
  render: renderAudioEditor,
};
